import _soundCheck from '@/utils/soundCheck/index.mjs';

export default function soundCheck() {
  const audioContext = new AudioContext();
  return _soundCheck(audioContext);
}
